import axios from 'axios';

export const s3 = axios.create({
  headers: {Accept: 'application/json'},
});
